import React from 'react';
import './ModernBlocks.css';

const ServicesBlock = ({ data }) => {
  return (
    <section className="services-section">
      <div className="services-container">
        <div className="services-header">
          <h2 className="services-title">
            {data.title}
          </h2>
          <p className="services-subtitle">
            {data.subtitle}
          </p>
        </div>
        <div className="services-grid">
          {data.items.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                <span style={{ fontSize: '2.5rem' }}>{service.icon}</span>
              </div>
              <h3 className="service-title">
                {service.title}
              </h3>
              <p className="service-description">
                {service.description}
              </p>
              <ul className="service-features">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex}>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesBlock; 